// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3cb115e","239":"fb2c95e3","455":"8b43773a"}[chunkId] + ".chunk.js";
};